export const url = process.env.REACT_APP_API_URL
export const trackingId = process.env.REACT_APP_TRACKING_ID
export const assetsOwnerPdf =
  "https://support.visual-alpha.com/VA_Asset_Owner_User_Manual.pdf"
export const assetsManagerPdf =
  "https://support.visual-alpha.com/VA_Asset_Manager_Data_Import_User_Manual.pdf"
